const accountNameStandardised = (data) =>
  data?.toLowerCase()?.replace(/\b[a-z]/g, (char) => char.toUpperCase());

export default accountNameStandardised;
